"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgBiDirectional(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M20 0H4v16h16zm-8 10l-3 3-3-3h2V4h2v6zm6-4h-2v6h-2V6h-2l3-3z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('BiDirectional')(SvgBiDirectional);
//# sourceMappingURL=BiDirectional.js.map